import React from 'react';
import { Link } from 'react-router-dom';

const EmailLink = ({ email, subject, body }) => {
 
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  return (
    <a className='text-[#2256a9]' href={mailtoLink} target="_blank"
  rel="noopener noreferrer"
>
      {email}
    </a>
  );
};

export default EmailLink;
